var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #faab54;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.5,4.7c.3,0,.5.2.5.4s0,.3-.2.4l-3.1,2.9.7,4.1s0,0,0,.2c0,.1,0,.2,0,.3,0,0-.1.1-.3.1s-.2,0-.3,0l-3.8-1.9-3.8,1.9c-.1,0-.2,0-.3,0s-.2,0-.3-.1c0,0,0-.2,0-.3s0,0,0-.2l.7-4.1L.2,5.4c-.1-.1-.2-.3-.2-.4,0-.2.2-.3.5-.4l4.2-.6L6.6.3c.1-.2.2-.3.4-.3s.3.1.4.3l1.9,3.7,4.2.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.07d380378b41780ffbffad90b5b3c488.svg";
export { ForwardRef as ReactComponent };